import { Navigate } from 'react-router-dom';

export default function ProductsList() {
  return <Navigate to="/search?searchType=products" replace />;
}
